import { FormattedMessage, useIntl } from "react-intl";
import {
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from "@fluentui/react-components";

import type { Interview } from "@aglocal/schema/Interview";

import Callout from "@aglocal/web/components/Callout";

import ConnectedDetails from "@/components/ConnectedDetails";

export interface ConnectedDetailsAccordionItemProps {
  name: unknown;
  interview: Interview;
}

export default function ConnectedDetailsAccordionItem({
  name,
  interview: { interviewee },
}: ConnectedDetailsAccordionItemProps) {
  const { $t } = useIntl();
  return (
    <AccordionItem value={name}>
      <AccordionHeader>
        <FormattedMessage
          defaultMessage="Connected Details"
          description="Header of the drawer section showing the talent's Connected profile."
        />
      </AccordionHeader>
      <AccordionPanel>
        {interviewee?.connectedDetails == null ? (
          <Callout
            intent="warning"
            title={$t({
              defaultMessage: "Connected Details not found",
              description:
                "Shown in the drawer when the talent has no Connected profile linked.",
            })}
          />
        ) : (
          <ConnectedDetails details={interviewee.connectedDetails} />
        )}
      </AccordionPanel>
    </AccordionItem>
  );
}
